// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__GZGgr","spinner":"Spinner_spinner__lWRh3","spin":"Spinner_spin__wwu8z","white":"Spinner_white__YuEaq"};